var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16H27V32H32V16Z",
    fill: "#EF916C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16H0V32H5V16Z",
    fill: "#EF916C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0133 0L7 7.9744V32H12.969V23.6416H19.031V32H25V7.9744L16.0133 0ZM19.2233 13.792H17.2336C17.2336 14.0992 17.1071 14.3939 16.882 14.6111C16.6569 14.8284 16.3515 14.9504 16.0332 14.9504C15.7148 14.9504 15.4094 14.8284 15.1843 14.6111C14.9592 14.3939 14.8327 14.0992 14.8327 13.792H12.8364C12.6247 13.792 12.4216 13.7113 12.2713 13.5675C12.121 13.4236 12.0356 13.2283 12.0339 13.024C12.0349 12.832 12.1103 12.6474 12.2453 12.5064C12.3804 12.3655 12.5652 12.2784 12.7634 12.2624V9.12C12.8761 8.35722 13.2701 7.65927 13.8732 7.15434C14.4763 6.64941 15.248 6.37142 16.0464 6.37142C16.8449 6.37142 17.6165 6.64941 18.2196 7.15434C18.8227 7.65927 19.2168 8.35722 19.3294 9.12V12.2624C19.5281 12.2865 19.71 12.3819 19.839 12.5297C19.968 12.6775 20.0345 12.8667 20.0253 13.0597C20.0161 13.2527 19.9318 13.4353 19.7893 13.571C19.6468 13.7067 19.4566 13.7856 19.2564 13.792H19.2233Z",
    fill: "#F75B11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchools);
export default __webpack_public_path__ + "static/media/schools.1b3611f524471d9973932a4f46f548b7.svg";
export { ForwardRef as ReactComponent };